import { useQuery } from '@tanstack/react-query';
import { PARAMETER_COLLECTION } from 'constants/gcConstants';
import { G_PARAMETERS_QUERY_KEY } from 'constants/queryKeys';
import { GBase } from 'interfaces/IGlobalCatalogue';
import { GlobalCatalogueService } from 'services/GlobalCatalogueServices';

export const useFetchGParameters = () => {
  return useQuery<GBase[]>({
    queryKey: [G_PARAMETERS_QUERY_KEY],
    queryFn: () =>
      GlobalCatalogueService.FetchGReferenceCollectionData(
        PARAMETER_COLLECTION
      ),
    staleTime: 1000 * 60 * 30,
  });
};
